import { useEffect, useState } from "react";
import { LoadingCard } from "./LoadingListCards";
import SecondaryHeading from "./SecondaryHeading";
import "./util.css";
import PrimaryHeading from "./PrimaryHeading";
import Divider from "./Divider";

export default function ToggleCard({
  value,
  setValue,
  label = "",
  description = "",
  isLoading = false,
  heading = "",
  labelClass = "",
  showBottomLine = false,
  className = "",
  disabled = false,
  labelStyle = {},
}) {
  const [loading, setLoading] = useState(isLoading);
  useEffect(() => {
    if (isLoading) {
      setLoading(true);
    } else {
      setTimeout(() => {
        setLoading(isLoading);
      }, 100);
    }
  }, [isLoading]);
  return (
    <>
      {heading && (
        <PrimaryHeading className="text-17">{heading}</PrimaryHeading>
      )}
      {label && (
        <SecondaryHeading
          className={`text-14 mt-3 mb-1-5 ${labelClass}`}
          style={labelStyle}
        >
          {label}
        </SecondaryHeading>
      )}
      {description ? (
        <p className="body-text text-theme-secondary mt-0 mb-2">
          {description}
        </p>
      ) : (
        ""
      )}
      {loading ? (
        <LoadingCard className="h-4-5 toggle-card rounded-full" />
      ) : (
        <div
          className={`toggle-card ${
            !value ? "bg-disabled" : "bg-active"
          } ${className} ${disabled ? "opacity-50" : ""}`}
          onClick={() => (disabled ? null : setValue(!value))}
          style={{
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          <div
            className={`white-move-button 
          ${!value ? "translate-x-0" : "translate-x-full"}
          `}
          ></div>
        </div>
      )}
      {showBottomLine ? <Divider height={2} className="mt-4 mb-4" /> : ""}
    </>
  );
}
